import React, { useRef, useState } from "react";
import { FaWallet } from "react-icons/fa";
import { Button, CheckoutPayment, ConfettiAnimation, Form, Img, Input, Modal, PeachPayments, Toast } from "../../../../Components";
import { apis, post } from "../../../../Utils/axios";
import useUserProfile from "../../../../Hooks/useUserProfile";
import { useSearchParams } from "react-router-dom";
import { FiCreditCard } from "react-icons/fi";
import { useAdminPermission } from "Hooks/useAdminPermission";

function AddMoney({ currency, onReload = () => {} }) {
	
	const { checkAdminPermission } = useAdminPermission();
	const [searchParams] = useSearchParams();
	const { profile } = useUserProfile();
	const [ShowAddMoney, setShowAddMoney] = useState(false);

	const [Loading, setLoading] = useState(false);
	const [OngoingPayment, setOngoingPayment] = useState(false);

	const [Values, setValues] = useState({});

	const [CheckoutOrder, setCheckoutOrder] = useState();
	const [PeachOrder, setPeachOrder] = useState();

	const createOrder = () => {
		setLoading(true);
		post(
			apis.orderWalletRecharge,
			{
				amount: Values.amount,
				currency: currency,
			},
			(r, e) => {
				if (r) {
					setOngoingPayment(true);
					if (currency === "ZAR") {
						//Peach Payments
						const order = {
							entityId: r.entityId,
							amount: Values.amount,
							orderId: r.orderId,
							checkoutId: r.checkoutId,
							user: { name: profile ? `${profile.fName} ${profile.lName}` : "", email: profile?.email, phone: profile?.phone },
							pgSurcharge: r.pgSurcharge,
							surchargeAmount: r.surchargeAmount,
						};
						setPeachOrder(order);
					}
					if (currency === "AED") {
						//Checkout.com
						setCheckoutOrder({ url: r.checkoutUrl, orderId: r.orderId, pgSurcharge: r.pgSurcharge, surchargeAmount: r.surchargeAmount });
					}
				} else {
					Toast.handleError(e);
					setOngoingPayment(false);
					setLoading(false);
				}
			}
		);
	};

	const onClose = () => {
		setShowAddMoney(false);
		setOngoingPayment(false);
		setValues({});
		setCheckoutOrder();
		setPeachOrder();
		setLoading(false);
	};

	if (!checkAdminPermission("EDIT_PAYMENT")) return null;

	return (
		<>
			<div onClick={() => setShowAddMoney(!ShowAddMoney)} className="p-4 text-white rounded-xl transition-all cursor-pointer bg-accent hover:bg-primary flex-center">
				<h1 className="gap-4 text-lg align-center">
					<FaWallet /> + Add Money
				</h1>
			</div>
			<Modal open={ShowAddMoney} onClose={!OngoingPayment ? onClose : () => {}}>
				<div className="flex justify-center items-center h-full">
					{!OngoingPayment && (
						<div className="p-6 space-y-8 text-center">
							<Img src="https://cdn.travelwings.com/assets/corp/images/intros/locker.png" alt="Locker" className="max-w-[10rem] m-auto mb-6" />
							<div>
								<h1>Add money to wallet</h1>
								<div className="text-label">Enter the amount you want to add to your wallet</div>
							</div>
							<Form onSubmit={createOrder} className="space-y-8">
								<div>
									<Input value={Values.amount} min={0} onChange={(amount) => setValues((prev) => ({ ...prev, amount }))} placeholder={`Enter amount in ${currency}`} name="amount" type="number" required />
									<p className="mt-1 text-[0.7rem] text-left opacity-50">Surcharge will be calculated on next screen</p>
								</div>
								<div className="gap-2 flex-center">
									<Button loading={Loading} variant="primary" type="submit" className="gap-4">
										<FiCreditCard />
										Pay Now
									</Button>
									<Button variant="outlined" onClick={onClose}>
										Cancel
									</Button>
								</div>
							</Form>
						</div>
					)}
					{CheckoutOrder && <CheckoutPayment order={CheckoutOrder} onClose={onClose} />}
					{PeachOrder && <PeachPayments order={PeachOrder} onClose={onClose} />}
				</div>
			</Modal>
			<ConfettiAnimation show={searchParams.get("recharge") === "success"} />
		</>
	);
}

export default AddMoney;
